export default __webpack_public_path__ + "static/media/wire-frame.3ac55309.svg";